<h2 mat-dialog-title>Reports</h2>
<mat-dialog-content class="mat-typography">
    <div class="maxheight500">
        <div layout="row">
            <mat-list>
                <mat-list-item class="width-100" *ngFor="let report of reports; let i = index">
                    <mat-checkbox (change)="onReportChecked($event.checked, i,  report)" [(ngModel)]="reports[i].selected">{{ report.name }}</mat-checkbox>
                </mat-list-item>
            </mat-list>
        </div>
    </div>
</mat-dialog-content>
<br/>
<mat-divider></mat-divider>
<br/>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="onCancelClick()">Cancel</button>
    <button mat-button [mat-dialog-close]="true" (click)="onLinkReportClick()" cdkFocusInitial>Save</button>
</mat-dialog-actions>
